import React, { useState } from 'react';
import { Formik, Field, useFormikContext, FormikContextType } from 'formik';
import FormSelect from 'shared/Inputs/FormSelect';
import { MODE, NewTermFormData, Props, Route, RouteViewModel, Term, TermViewModel } from './types';
import Button from 'shared/Button/Button';
import FormInput from 'shared/Inputs/FormInput';
import { percentageMask } from 'shared/Inputs/inputMasks';

const NetworkCommissionTerms: React.FC<Props> = ({ terms, route, onAddNewTerm, allowCreate = false }: Props) => {
  const [mode, setMode] = useState<MODE>(MODE.EDIT);
  const termViewModels: TermViewModel[] = terms.map((term: Term) => ({
    key: `term-key-${term.id}`,
    label: term.name || '',
    value: term.value || '',
  }));
  const routeViewModel: RouteViewModel[] = route.map((route: Route) => ({
    key: `term-key-${route.id}`,
    label: route.name || '',
    value: route.value || null,
  }));

  const { values }: FormikContextType<any> = useFormikContext();

  const headlineText = mode === MODE.EDIT ? 'Submission Route' : MODE.ADD ? 'Create new commission terms' : '';

  const handleAddNewTerm = () => {
    setMode(MODE.ADD);
  };

  const cancelAddingNewTerm = () => {
    setMode(MODE.EDIT);
  };

  const handleSaveNewTerm = (values: NewTermFormData, { resetForm }: any) => {
    if (onAddNewTerm) {
      onAddNewTerm(values);
    }

    resetForm();
  };

  return (
    <>
      <div className="form__header">
        <h2 className="plum no-margin">{headlineText}</h2>
      </div>

      {mode === MODE.EDIT && (
        <>
          <Field
            name="submissionRoute"
            component={FormSelect}
            label="Please select the preferred submission route"
            options={routeViewModel.map((route) => ({
              id: route.key,
              value: route.value,
              option: route.label,
            }))}
          />

          {values.submissionRoute === 'Direct' && (
            <Field
              name="commissionTerms"
              component={FormSelect}
              label="Select commission term"
              options={termViewModels.map((term) => ({
                id: term.key,
                value: term.value,
                option: term.label,
              }))}
            />
          )}

          {allowCreate && (
            <div>
              <span>Or Configure New Terms</span>
              <div className="controls">
                <Button type="button" className="button button--plum" label="Create terms" onClick={handleAddNewTerm} />

                <Button type="button" className="button button--plum" label="Confirm" />
              </div>
            </div>
          )}
        </>
      )}
      {mode === MODE.ADD && allowCreate && (
        <Formik
          initialValues={{
            name: '',
            amount: 0,
          }}
          onSubmit={handleSaveNewTerm}>
          {({ submitForm }) => (
            <div>
              <Field name="name" component={FormInput} label="Enter Term Name" />

              <Field name="amount" component={FormInput} label="Amount %" mask={percentageMask} />

              <div className="controls">
                <Button type="button" className="button button--plum" label="Cancel" onClick={cancelAddingNewTerm} />

                <Button type="button" className="button button--plum" label="Submit" onClick={submitForm} />
              </div>
            </div>
          )}
        </Formik>
      )}
    </>
  );
};

export default NetworkCommissionTerms;
